import { useEffect } from "react";
import { Link } from "react-router-dom";

const services = [
  {
    icon: "ri-movie-2-line",
    title: "电影资源汇总",
    desc: "汇总最新上映与经典电影信息，涵盖科幻、动作、悬疑、剧情等多种类型，方便观众快速筛选浏览。",
  },
  {
    icon: "ri-tv-2-line",
    title: "电视剧剧集库",
    desc: "整理热播剧集与精品好剧，涵盖历史、都市、悬疑、科幻等多题材，提供剧集信息与推荐。",
  },
  {
    icon: "ri-newspaper-line",
    title: "影视资讯报道",
    desc: "持续跟踪最新影视动态，提供行业资讯、剧集消息、人物专访与经典回顾等深度内容。",
  },
  {
    icon: "ri-search-2-line",
    title: "智能搜索筛选",
    desc: "支持按关键词搜索影视与资讯，并提供类型、地区、年份等多条件组合筛选与排序。",
  },
];

export default function AboutPage() {
  useEffect(() => {
    document.title = "关于我们 - 麻豆网站";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) {
      desc.setAttribute(
        "content",
        "麻豆网站是一个面向影视爱好者的综合信息平台，提供电影、电视剧资源汇总与最新影视资讯，仅作信息展示。"
      );
    }
  }, []);

  return (
    <div className="w-full">
      {/* 头部 */}
      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-primary-900">
        <div className="max-w-4xl">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-widest uppercase text-accent-400 mb-3">
            <span className="w-4 h-0.5 bg-accent-400 inline-block" />
            About Us
          </span>
          <h1 className="text-3xl md:text-5xl font-black text-background-50 mb-4">关于麻豆网站</h1>
          <p className="text-sm md:text-base text-primary-100/90 leading-relaxed max-w-3xl">
            麻豆网站是一家面向广大影视爱好者的综合影视信息平台，专注于为普通观众提供丰富、实时更新的影视资源汇总与最新影视资讯报道。
          </p>
        </div>
      </section>

      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        {/* 站点理念 */}
        <section className="mb-14 max-w-4xl">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4">站点理念</h2>
          <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              我们相信，好的内容值得被更好地发现。麻豆网站希望成为影迷了解影视世界的一扇窗口——用清晰的结构、丰富的条目与及时的资讯，帮助你在海量的影视作品中快速找到想看的内容。
            </p>
            <p>
              我们把重心放在<strong className="text-foreground-950">信息的完整性与更新的及时性</strong>上：每一部作品都尽可能提供准确的类型、地区、年份、主创与剧情概要，每一条资讯都力求简明真实。没有花哨的干扰，只有干净、易读、值得信赖的内容。
            </p>
            <p>
              同时我们始终坚持一个原则：<strong className="text-foreground-950">本站仅提供影视信息展示</strong>，不提供在线播放、下载或会员服务。我们希望做的是信息的整理者与传播者，而非内容的提供者。
            </p>
          </div>
        </section>

        {/* 内容服务范围 */}
        <section className="mb-14">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6">内容与服务范围</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {services.map((s) => (
              <div key={s.title} className="p-5 md:p-6 bg-background-50 border border-background-200 rounded-lg">
                <span className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-4">
                  <i className={`${s.icon} text-xl text-primary-600`} />
                </span>
                <h3 className="text-base font-bold text-foreground-950 mb-2">{s.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-5 p-4 rounded-lg bg-accent-50 border border-accent-200 text-sm text-accent-900 flex items-start gap-3">
            <i className="ri-information-line text-lg mt-0.5 flex-shrink-0" />
            <p>本站所有影视与资讯内容均为演示资料，仅用于平台功能演示与信息展示，不涉及任何实际影片资源的存储、播放与下载。</p>
          </div>
        </section>

        {/* 联系方式 */}
        <section className="mb-14">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6">联系我们</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="p-6 bg-background-50 border border-background-200 rounded-lg">
              <span className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center mb-3">
                <i className="ri-mail-line text-lg text-secondary-600" />
              </span>
              <h3 className="text-sm font-bold text-foreground-950 mb-1">合作邮箱</h3>
              <p className="text-sm text-foreground-600 break-all">contact@madou-example.com</p>
            </div>
            <div className="p-6 bg-background-50 border border-background-200 rounded-lg">
              <span className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mb-3">
                <i className="ri-service-line text-lg text-primary-600" />
              </span>
              <h3 className="text-sm font-bold text-foreground-950 mb-1">内容建议</h3>
              <p className="text-sm text-foreground-600 break-all">feedback@madou-example.com</p>
            </div>
            <div className="p-6 bg-background-50 border border-background-200 rounded-lg flex items-center gap-4">
              <div className="w-24 h-24 flex-shrink-0 rounded-md overflow-hidden bg-background-200 border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=minimal%20clean%20placeholder%20graphic%20of%20a%20qr%20code%20with%20a%20small%20green%20logo%20in%20the%20center%2C%20flat%20simple%20design%2C%20white%20background%2C%20highly%20detailed&width=300&height=300&seq=madou-wechat-qr&orientation=squarish"
                  alt="微信公众号二维码"
                  title="麻豆网站 微信公众号"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h3 className="text-sm font-bold text-foreground-950 mb-1">微信公众号</h3>
                <p className="text-sm text-foreground-600">扫码关注「麻豆影视」</p>
              </div>
            </div>
          </div>
        </section>

        {/* 隐私政策与用户协议 */}
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="p-6 md:p-7 bg-background-50 border border-background-200 rounded-lg">
            <h2 className="text-lg font-bold text-foreground-950 mb-3 flex items-center gap-2">
              <i className="ri-shield-user-line text-primary-500" />
              隐私政策
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed">
              本站尊重并保护用户隐私。浏览本站内容无需注册或登录，我们不会主动收集你的个人身份信息，也不会将浏览数据用于商业用途。若未来引入数据统计或表单功能，我们将在此页面更新相关说明。
            </p>
          </div>
          <div className="p-6 md:p-7 bg-background-50 border border-background-200 rounded-lg">
            <h2 className="text-lg font-bold text-foreground-950 mb-3 flex items-center gap-2">
              <i className="ri-file-list-3-line text-secondary-500" />
              用户协议
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed">
              使用本站即表示你同意：本站所展示的影视与资讯内容仅用于信息浏览，不得用于任何商业用途。本站不提供影片播放与下载服务，所有内容版权归各自权利人所有。如有内容涉及侵权，请通过上方邮箱与我们联系。
            </p>
          </div>
        </section>

        <div className="mt-12 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
        </div>
      </div>
    </div>
  );
}